import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import RfSignal from '../images/rf-indicators/rf-signal.svg';
import RfSignal433 from '../images/rf-indicators/rf-signal.sensor-433.svg';
import RfSignal1 from '../images/rf-indicators/rf-signal.level-1.svg';
import RfSignal2 from '../images/rf-indicators/rf-signal.level-2.svg';
import RfSignal3 from '../images/rf-indicators/rf-signal.level-3.svg';
import RfBattery from '../images/rf-indicators/rf-battery.svg';
import RfBattery0 from '../images/rf-indicators/rf-battery.level-0.svg';
import RfBattery1 from '../images/rf-indicators/rf-battery.level-1.svg';
import RfBattery2 from '../images/rf-indicators/rf-battery.level-2.svg';
import RfBattery3 from '../images/rf-indicators/rf-battery.level-3.svg';
function getRfBatteryIcon(level) {
    switch (level) {
        case 0:
            return _jsx(RfBattery0, {});
        case 1:
            return _jsx(RfBattery1, {});
        case 2:
            return _jsx(RfBattery2, {});
        case 3:
            return _jsx(RfBattery3, {});
        default:
            return _jsx(RfBattery, {});
    }
}
export const RFBatteryIndicator = memo(function RFBatteryIndicator({ bat, bat_v, }) {
    const str = useMemo(() => (bat_v != null ? `${bat_v.toFixed(1)} В` : ''), [bat_v]);
    const level = useMemo(() => bat != null
        ? Math.trunc(bat / 4)
        : bat_v != null
            ? Math.min(~~(Math.min(Math.max(bat_v - 2, 0), 1) * 4), 3)
            : 0, [bat, bat_v]);
    return (_jsx(Tooltip, { title: str, children: _jsx("span", { children: getRfBatteryIcon(level) }) }));
});
function getRfIcon(level, is433) {
    if (is433) {
        return _jsx(RfSignal433, {});
    }
    switch (level) {
        case 1:
            return _jsx(RfSignal1, {});
        case 2:
            return _jsx(RfSignal2, {});
        case 3:
            return _jsx(RfSignal3, {});
        default:
            return _jsx(RfSignal, {});
    }
}
export const RFSignalIndicator = memo(function RFSignalIndicator(props) {
    const { dbm, is_433 } = props;
    const level = useMemo(() => (dbm == null ? 0 : dbm >= -70 ? 3 : dbm >= -80 ? 2 : dbm >= -90 ? 1 : 0), [dbm]);
    const str = useMemo(() => dbm != null
        ? `${dbm} дБм`
        : is_433
            ? 'Датчик подключен по радиоканалу 433МГц'
            : '', [dbm, is_433]);
    return (_jsx(Tooltip, { title: str, children: _jsx("span", { children: getRfIcon(level, !!is_433) }) }));
});
export const RFIndicators = memo(function RFIndicators(props) {
    const { rf, show_values } = props;
    if (rf == null) {
        return null;
    }
    return (_jsxs(Box, { display: "flex", alignItems: "center", mt: 0.5, children: [rf.dbm != null && (_jsxs(_Fragment, { children: [_jsx(RFSignalIndicator, { ...rf }), show_values && (_jsx(Box, { ml: "0.5ex", children: _jsxs(Typography, { variant: "body1", color: "textSecondary", children: [rf.dbm, " \u0434\u0411\u043C"] }) }))] })), (rf.bat != null || rf.bat_v != null) && (_jsxs(Box, { ml: "0.5ex", display: "flex", children: [_jsx(RFBatteryIndicator, { ...rf }), show_values && rf.bat_v != null && (_jsx(Box, { ml: "0.5ex", children: _jsxs(Typography, { variant: "body1", color: "textSecondary", children: [rf.bat_v.toFixed(1), " \u0412"] }) }))] }))] }));
});
